import { TreeCardObject } from '../tree-card/tree-card-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { ProductStatusObject } from '../product-status-object.model';
import { ProductTypeObject } from '../product-type-object.model';

export class RfsObject extends TreeCardObject {

  constructor(name: string, completed: boolean, crmId: string, operation: string,
    status: string, dependencies: boolean, index: number, productId: string, specId: string) {
    super(name, 'RFS', StringUtils.NOT_AVALIABLE, completed, crmId, operation,
      ProductStatusObject.createWithStatus(status), dependencies, 3, index, productId, specId, ProductTypeObject.RFS);
    return this;
  }
}
